module.exports = __webpack_public_path__ + "b84539db3cee8bf9506eb617fc708c22.png";